import React from 'react';

const SEOSettingsPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default SEOSettingsPage;
